/*
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
/*
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */ export var COMPUTE_WIDTH_CLASS = "datagrid-computing-columns-width";
export var STRICT_WIDTH_CLASS = "datagrid-fixed-width";
//# sourceMappingURL=constants.js.map


//////////////////
// WEBPACK FOOTER
// ./~/clarity-angular/data/datagrid/render/constants.js
// module id = 89
// module chunks = 4